import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectBlockState } from './block.selectors';
import { selectSystemState } from './system.selectors';

export const selectSystemMonthlyYearlyEnergy = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.MonthlyYearlyEnergyOverviewComponent
);

export const selectSystemEnergyStateBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectSystemMonthlyYearlyEnergy,
  (systemState, energyDataOverviewComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = energyDataOverviewComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.systemEnergyState;
  }
);

export const selectSystemEnergyModeBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectSystemMonthlyYearlyEnergy,
  (systemState, energyDataOverviewComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = energyDataOverviewComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.mode;
  }
);

export const selectSystemEnergyRangeBySelectedSystem = (instanceId: string) => createSelector(
  selectSystemState,
  selectSystemMonthlyYearlyEnergy,
  (systemState, energyDataOverviewComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = energyDataOverviewComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.range;
  }
);

export const selectedSystemMonthlyYearlyEnergyRequestStatus = (instanceId: string) => createSelector(
  selectSystemState,
  selectSystemMonthlyYearlyEnergy,
  (systemState, energyDataOverviewComponent) => {
    const selectedSystem = systemState.selectedSystemUid;
    if (!selectedSystem) {
      return null;
    }

    const instanceBlock = energyDataOverviewComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }

    return instanceBlock[selectedSystem]?.state;
  }
);